import React from 'react';

import Image from '../../../../library/image/image';
import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';

import { useMediaQuery } from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';

import './wheel-configurator-banner.scss';

function WheelConfiguratorBanner() {
  const breakpoint = useMediaQuery();

  return (
    <div styleName="container">
      <div styleName="banner-text-cta">
        <Typography
          size={breakpoint?.isMinSm ? 'regular' : 'small'}
          styleName="banner-text"
          tag="div"
        >
          See wheels on your vehicle before you buy
          <Link
            onClick={() => {
              trackAction('use_our_wheel_visualizer_click');
            }}
            size={breakpoint?.isMinSm ? undefined : 'small'}
            styleName="banner-link"
            to="/wheel-visualizer"
          >
            use our wheel visualizer
          </Link>
        </Typography>
      </div>
      <div styleName="wheel-images">
        <Image
          alt="Black Wheel"
          src="https://cdn.discounttire.com/sys-master/images/h01/h77/9367519264798/PRODUCT_202004250327_wheel_36530_1000_front.png_dt-product-desktop"
          styleName="wheel-image-one"
        />
        <Image
          alt="Chrome Wheel"
          src="https://cdn.discounttire.com/sys-master/images/he0/h47/9382923763742/PRODUCT_202004250213_wheel_75905_1000_front.png_dt-product-desktop"
          styleName="wheel-image-two"
        />
        <Image
          alt="Flat Black Wheel"
          src="https://cdn.discounttire.com/sys-master/images/hfc/h84/9574924845086/PRODUCT_202101220951_wheel_77123_1000_front.png_dt-product-desktop"
          styleName="wheel-image-three"
        />
      </div>
    </div>
  );
}

export default WheelConfiguratorBanner;
